import { Injectable } from "@angular/core";
import { ReviewTypeEnum } from "../enums/review-type.enum";
import { TextGuide } from "../models/text-guide.model";

@Injectable({
    providedIn: 'root'
})
export class TextGuideService {

    private textGuides: TextGuide[] = [
        {   key: 'assessment:TER',
            titleKey: 'TEXT_GUIDE.PANORAMA_AURA_TITLE',
            titleIndexText: '®',
            subtitleKey: 'TEXT_GUIDE.PANORAMA_AURA_SUBTITLE',
            logoLink: '/assets/img/logo-panorama.png',
            reviewType: ReviewTypeEnum.TER,
            category: 'assessment',
            urls: [`/config/html/{lang}/guide-panorama-tajekoztato_{lang}.html`, `/config/html/{lang}/guide-panorama-technikai-segitseg_{lang}.html`],
            rightPanelRatio: 48
        },
        {   key: 'assessment:SZILUETT',
            titleKey: 'TEXT_GUIDE.SZILUETT_TITLE',
            titleIndexText: '®',
            subtitleKey: 'TEXT_GUIDE.SZILUETT_SUBTITLE',
            logoLink: '/assets/img/logo-sziluett.png',
            reviewType: ReviewTypeEnum.PersonalityTest,
            category: 'assessment',
            urls: [`/config/html/{lang}/guide-sziluett-tajekoztato_{lang}.html`, `/config/html/{lang}/guide-sziluett-technikai-segitseg_{lang}.html`],
            rightPanelRatio: 45
        },
        {   key: 'assessment:MilioTeamDysfunction',
            titleKey: 'TEXT_GUIDE.MILIO_TITLE',
            titleIndexText: '®',
            subtitleKey: 'TEXT_GUIDE.MILIO_TEAM_OPTIMIZATION_SUBTITLE',
            logoLink: '/assets/img/logo-milio.png',
            reviewType: ReviewTypeEnum.MilioTeamDysfunction,
            category: 'assessment',
            urls: [`/config/html/{lang}/guide-milio-diszfunkciok-tajekoztato_{lang}.html`, `/config/html/{lang}/guide-milio-diszfunkciok-technikai-segitseg_{lang}.html`],
            rightPanelRatio: 38
        },
        {   key: 'assessment:MilioStressMap',
            titleKey: 'TEXT_GUIDE.MILIO_TITLE',
            titleIndexText: '®',
            subtitleKey: 'TEXT_GUIDE.MILIO_STRESS_MAP_SUBTITLE',
            logoLink: '/assets/img/logo-milio.png',
            reviewType: ReviewTypeEnum.MilioStressMap,
            category: 'assessment',
            urls: [`/config/html/{lang}/guide-milio-stressmap-tajekoztato_{lang}.html`, `/config/html/{lang}/guide-milio-stressmap-technikai-segitseg_{lang}.html`],
            rightPanelRatio: 39
        },
        {   key: 'reports:TER',
            titleKey: 'TEXT_GUIDE.REPORTS_INDIVIDUAL_TITLE',
            reviewType: ReviewTypeEnum.TER,
            category: 'reports',
            urls: ['/config/html/reports.html'],
        },
        {   key: 'goals:TER',
            titleKey: 'TEXT_GUIDE.PANORAMA_AURA_TITLE',
            titleIndexText: '®',
            subtitleKey: 'TEXT_GUIDE.GOALS_PANORAMA_AURA_SUBTITLE',
            logoLink: '/assets/img/logo-panorama.png',
            reviewType: ReviewTypeEnum.TER,
            category: 'goals',
            urls: [`/config/html/{lang}/guide-goals-tajekoztato_{lang}.html`, `/config/html/{lang}/guide-goals-technikai-segitseg_{lang}.html`]
        }
    ]

    constructor() {

    }
    
    public getGuide(key: string): TextGuide {
        const guide = this.textGuides.find(x => x.key === key);
        return guide;
    }

    public getGuideForReviewType(category: string, reviewType: ReviewTypeEnum): TextGuide {
        const guide = this.textGuides.find(x => x.category == category && x.reviewType === reviewType);
        return guide;
    }
}
